import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { cambiarStringApp } from '../../actions';
import history from '../../history';
import './ModalError.css';

class ModalError extends Component {
  handleCerrarModal = () => {
    this.props.cambiarStringApp('mostrar_error_app', false);
    this.props.cambiarStringApp('error_app', '');

    if (this.props.error_app === 'El artículo no existe.') {
      history.replace(`/${this.props.idioma}/`);
      // setTimeout(() => { window.scrollTo(0, 0); }, 100);
      window.scrollTo(0, 0);
    }
  }

  handleStopPropagation(e) { e.stopPropagation(); }

  renderContenido() {
    if (this.props.visible === true) {
      return ReactDOM.createPortal(
        <>
          <div className="contenedorModal" onClick={this.handleCerrarModal} />

          <div className="contenidoModal" onClick={this.handleStopPropagation}>
            <div className="textoAzul">{this.props.texto}</div>
            <button className="botonCerrar" onClick={this.handleCerrarModal} type="button">{this.props.textoCancelar || 'Cerrar' }</button>
          </div>
        </>,
        document.querySelector('#modalError')
      );
    }

    return null;
  }

  render() {
    return (
      <div>
        {this.renderContenido()}
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { idioma, error_app, mostrar_error_app } = app;

  return { idioma, error_app, mostrar_error_app };
};

export default connect(mapStateToProps, { cambiarStringApp })(ModalError);
